export default __webpack_public_path__ + "images/btcIcon_d910f3.svg";